export default __webpack_public_path__ + "static/media/scss.fcf040d4.png";